import { authenticate, ILogOnInfo } from '@cian/auth';
import { IHttpApi } from '@cian/http-api';

import { TNotificationFrequency } from '../filters/components/save/popup';
import { IJsonQuery } from '../json_query';
import {
  fetchCreateSubscription,
  ICreateSubscriptionRequest,
  TCreateSubscriptionResponse,
} from '../repositories/monolith-python/v1/create-subscription';

export interface INewSubscribeOptions {
  email: string;
  jsonQuery: IJsonQuery;
  title?: string;
  source?: TSubscriptionSource;
  subscribeNews: boolean;
  enableNotification?: boolean;
  notificationFrequency: TNotificationFrequency;
}

export interface IRequestSubscribeNewResponse {
  auth: boolean;
  subscribe: boolean;
}

export type TSubscriptionSource = 'listing' | 'map';

export interface ISubscribeResponse {
  status: 'ok' | 'error';
}

export async function requestSubscribeNew(
  httpApi: IHttpApi,
  options: INewSubscribeOptions,
): Promise<IRequestSubscribeNewResponse> {
  const responseData: TCreateSubscriptionResponse = await fetchCreateSubscription({
    httpApi,
    parameters: {
      ...options,
      source: options.source as ICreateSubscriptionRequest['source'],
      notificationFrequency: options.notificationFrequency as ICreateSubscriptionRequest['notificationFrequency'],
    },
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']],
        withCredentials: false,
      },
    },
  });

  if (responseData.statusCode === 400) {
    throw responseData;
  }

  const logonInfo = responseData.response.data.logonInfo;
  const subscribe = responseData.response.status === 'ok';

  if (logonInfo && logonInfo.logOnInfo && logonInfo.login) {
    return authenticate(logonInfo.logOnInfo as ILogOnInfo[], logonInfo.login, true).then(() => {
      if (window.__reloadHeader__) {
        window.__reloadHeader__();
      }

      return {
        auth: true,
        subscribe,
      };
    });
  } else {
    return {
      auth: false,
      subscribe,
    };
  }
}
